import React, { createContext, useContext } from "react";

import type { CookieKey } from "../native-modules/types/RNCoreNativeModule";

export type CookiesRecord<K extends CookieKey = CookieKey> = Partial<Record<K, string | null>>;

const CookiesContext = createContext<CookiesRecord | null>(null);

export function useCookies<K extends CookieKey = CookieKey>(): CookiesRecord<K> {
  const context = useContext(CookiesContext);
  if (!context) {
    throw new Error("CookiesContext used without initialization");
  }
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
  return context as CookiesRecord<K>;
}

export function CookieProvider<K extends CookieKey>({
  cookies,
  children,
}: {
  cookies: CookiesRecord<K>;
  children: React.ReactNode;
}) {
  return <CookiesContext.Provider value={cookies}>{children}</CookiesContext.Provider>;
}
